import { render, staticRenderFns } from "./couponSum.vue?vue&type=template&id=179753f2&scoped=true"
import script from "./couponSum.vue?vue&type=script&lang=js"
export * from "./couponSum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179753f2",
  null
  
)

export default component.exports